import React from 'react';

const Editorial = (props) => (
    <article className="sub-module module_editorial">
        <header>
            <h1>{props.header}</h1>
        </header>
        <div className="content">
            <p>{props.content}</p>
        </div>
    </article>
);

Editorial.propTypes = {
    header: React.PropTypes.string,
    content: React.PropTypes.string
};

export default Editorial;



// WEBPACK FOOTER //
// ./app/common/Editorial.js